import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const EditPatientProfile = () => {
  const { auth } = useAuth();
  const { state } = useLocation();
  const [values, setValues] = useState({});
  const [file, setFile] = useState(null);
  const [alert, setAlert] = useState(state ? state : null);
  const [img, setImg] = useState();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setAlert(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get(
          `user/patient/${auth?.user.id}/`
        );
        setValues(response?.data);
        setImg(response?.data.user_detail.user_image);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchData();
  }, []);

  const onChange = (e) => {
    if (e.target.name === "user_image") {
      setFile({ image: e.target.files });
      //retrieves the selected file
      const image = e.target.files[0];
      //reads the content of the file
      const reader = new FileReader();
      //updates the state with the url of image
      reader.onloadend = () => {
        setImg(reader.result);
      };
      reader.readAsDataURL(image);
    } else if (e.target.name === "name") {
      setValues({
        ...values,
        user_detail: { ...values.user_detail, [e.target.name]: e.target.value },
      });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const onSave = async () => {
    if (values?.user_detail.name === "") {
      showAlert("Enter your name.", "warning");
    } else if (
      values?.phone_number === null ||
      values?.phone_number === "" ||
      values?.phone_number.length !== 10
    ) {
      showAlert("Enter your valid 10-digit contact number.", "warning");
    } else if (
      values?.gender === null ||
      values?.gender === "" ||
      values?.gender === "Choose"
    ) {
      showAlert("Choose your gender.", "warning");
    } else if (values?.age === null || values?.age === "") {
      showAlert("Enter your age.", "warning");
    } else {
      try {
        const formData = new FormData();
        delete values.user_detail.user_image;
        await axiosPrivate.put(
          `user/patient/${auth?.user.id}/`,
          JSON.stringify(values)
        );
        //file is appended after checking its existence
        if (file !== null) {
          formData.append("user_image", file.image[0]);

          await axiosPrivate.put(
            `user/doctor/image/${auth?.user.id}/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        }
        navigate("/profile", {
          state: {
            message: "Profile Updated.",
            type: "success",
          },
        });
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Update Failed", "warning");
        }
      }
    }
  };

  return (
    <>
      <AlertField alert={alert} />
      <div className="bg-light m-3 p-2 m-md-5 px-md-5 py-3">
        <h2>Edit Profile</h2>
        <div className="row flex-column-reverse flex-md-row row-cols-md-2 mt-4">
          <div className="col">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>
                    <h4>Name</h4>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={values?.user_detail?.name || ""}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Email</h4>
                  </td>
                  <td>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={values?.user_detail?.email || ""}
                      disabled
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Contact No.</h4>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="phone_number"
                      id="phone_number"
                      maxLength={10}
                      value={values?.phone_number || ""}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Address</h4>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="address"
                      id="address"
                      value={values?.address || ""}
                      onChange={onChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Gender</h4>
                  </td>
                  <td>
                    <select
                      name="gender"
                      id="gender"
                      className="w-50 p-1"
                      onChange={onChange}
                      value={values?.gender || ""}
                    >
                      <option value="Choose">Choose</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Others">Others</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Age</h4>
                  </td>
                  <td>
                    <input
                      type="number"
                      name="age"
                      id="age"
                      value={values?.age || ""}
                      onChange={onChange}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col">
            <div className="mb-4 mx-5 d-flex flex-column align-items-center">
              <h4>Change Image</h4>
              <div className="position-relative">
                <img
                  src={img && img}
                  alt="user"
                  className="bg-white border border-dark rounded-circle"
                  width={200}
                  height={200}
                />
                <div className="position-absolute bottom-0 end-0 rounded-circle bg-secondary">
                  <label htmlFor="user_image" className="m-0">
                    <i className="fas fa-camera fs-3 p-2 text-black"></i>
                  </label>
                  <input
                    className="d-none"
                    type="file"
                    name="user_image"
                    accept="image/png, image/jpeg"
                    id="user_image"
                    onChange={onChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center text-md-end mx-md-5 px-md-5">
          <button className="px-4 btn btn-primary" onClick={onSave}>
            Save
          </button>
          <a href="/profile" className="mx-4 btn btn-danger">
            Cancel
          </a>
        </div>
      </div>
    </>
  );
};

export default EditPatientProfile;
